import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/authContext";

const withAuth = (WrappedComponent, allowedRoles = []) => {
  return (props) => {
    const navigate = useNavigate();
    const { checkAuth, isAuthenticated, admin, user } = useAuth();
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    
    useEffect(() => {
      const checkAuthorization = () => {
        // Проверяем токен
        const isValidToken = checkAuth();
        
        if (!isValidToken) {
          navigate("/login");
          return;
        }
        
        // Получаем роль пользователя
        const currentRole = localStorage.getItem("role");
        
        // Проверяем, разрешена ли роль
        if (allowedRoles.length > 0 && !allowedRoles.includes(currentRole)) {
          // Если роль не разрешена, перенаправляем на главную или показываем ошибку
          navigate("/login");
          return;
        }
        
        setIsAuthorized(true);
        setIsLoading(false);
      };
      
      checkAuthorization();
    }, [allowedRoles, navigate, checkAuth, isAuthenticated, admin, user]);
    
    // Показываем загрузку пока проверяем авторизацию
    if (isLoading) {
      return (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
          gap: '16px',
          fontFamily: 'Arial, sans-serif'
        }}>
          <div style={{ fontSize: '2rem', animation: 'spin 1s linear infinite' }}>⏳</div>
          <p style={{ color: '#666', margin: 0 }}>Проверка доступа...</p>
          <style>{`
            @keyframes spin {
              from { transform: rotate(0deg); }
              to { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      );
    }
    
    // Если не авторизован, ничего не показываем (компонент перенаправит)
    if (!isAuthorized) {
      return null;
    }
    
    return <WrappedComponent {...props} />;
  };
};

export default withAuth;